import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import DashboardController from "./DashboardController";
import EditController from "./EditController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('activity', {
                url: '/activity',
                abstract: true,
            })
            .state('activity.dashboard', {
                url: '/dashboard',
                template: require('./Dashboard.html'),
                controller: DashboardController,
                controllerAs: '$ctrl',
                data: {title: 'Activity Dashboard'}
            })
            .state('activity.edit', {
                url: '/{activityGuid}/edit',
                template: require('./Edit.html'),
                controller: EditController,
                controllerAs: '$ctrl',
                data: {title: 'Edit Activity'}
            })


    }
}

export default angular.module('app.activity', [])
    .config(Routes)
    .name;
